import { notNullOrUndefined } from '@app/helpers';
import { Entry } from 'contentful';
import { NavigationNode } from 'haba-contentful-components/lib/interfaces/navigation';
import { Category } from 'haba-emporix';

export function closeHeaderNavigation(document: Document) {
  const link = document.querySelector('.active');
  if (notNullOrUndefined(link)) {
    link.classList.remove('active');
  }
}

export function isShopNavigationNode(navigationNode: Entry<NavigationNode>): boolean {
  return navigationNode?.fields?.name?.trim()?.toLowerCase() === 'shop';
}

export function filterShopCategories(
  categories: Category[],
  shopNode: Entry<NavigationNode>
): Category[] {
  const shopNodeUrls = shopNode?.fields?.childNavigationNodes?.map((node) => node.fields.url) ?? [];

  return (categories ?? []).filter((category) =>
    shopNodeUrls.some((nodeUrl) => nodeUrl?.includes(category.code))
  );
}
